module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/SettingShipmentRules/SettingShipmentRules-list/SettingShipmentRules-list.component.scss
// module id = ./src/app/SettingShipmentRules/SettingShipmentRules-list/SettingShipmentRules-list.component.scss
// module chunks = main